import cogoToast from 'cogo-toast';
import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import { customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_RECON_PREVIEW, GET_RECON_PREVIEW_SUCCESS, GET_RECON_PREVIEW_ERROR } from './../../actionType.js';

function* getReconPreview({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/get-recon-preview`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
      params: {
        ...payload?.urlParam,
      },
      data: payload?.data,
    });

    if (response?.status === 200) {
      yield put({
        type: GET_RECON_PREVIEW_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: GET_RECON_PREVIEW_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_RECON_PREVIEW_ERROR, payload: error });
  }
}

export function* watchGetReconPreview() {
  yield takeEvery(GET_RECON_PREVIEW, getReconPreview);
}

function* getReconPreviewSaga() {
  yield all([fork(watchGetReconPreview)]);
}

export default getReconPreviewSaga;
